import * as types from "./mutation-types";
import Vue from "vue";
import router from "@/router";
import { authService } from "@/services";
import { messageHelper } from "@/helpers/message_helper";

export const login = async ({ commit, dispatch }, { email, password }) => {
  commit(types.SET_IS_LOADING, true);

  try {
    const response = await authService.login(email, password);

    dispatch("setTokens", {
      access: response.data.access,
      refresh: response.data.refresh
    });

    dispatch("setCurrentUser");
  } catch (error) {
    messageHelper.displayError("Email e/ou senha inválidos.");
  } finally {
    commit(types.SET_IS_LOADING, false);
  }
};

export const setTokens = async ({ commit }, { access, refresh }) => {
  commit(types.SET_ACCESS_TOKEN, access);
  commit(types.SET_REFRESH_TOKEN, refresh);
};

export const logout = async ({ dispatch }) => {
  dispatch("setTokens", { access: null, refresh: null });
  localStorage.clear();
  Vue.prototype.$vrm.setRoles(null);

  router.push({ name: "Login" });
};

export const setCurrentUser = async ({ commit }) => {
  try {
    const response = await authService.me();
    const role = response.data.data.attributes.role;
    Vue.prototype.$vrm.setRoles(role);
    commit(types.SET_CURRENT_USER, response.data.data);

    if (role == "marketing") {
      router.push({ name: "Companies" });
    } else if (
      role == "regional_manager" ||
      role == "state_agency_regional_manager"
    ) {
      router.push({ name: "Users" });
    } else if (role == "presale") {
      router.push({ name: "Leads" });
    } else {
      router.push({ name: "Dashboard" });
    }
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }
};

export const setUpdatesCurrentUser = async ({ commit }) => {
  try {
    const response = await authService.me();
    const role = response.data.data.attributes.role;
    Vue.prototype.$vrm.setRoles(role);
    commit(types.SET_CURRENT_USER, response.data.data);
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
  }
};

// eslint-disable-next-line no-unused-vars
export const recoverPassword = async ({ commit }, { email }) => {
  try {
    await authService.recoverPassword(email);
    return true;
  } catch (error) {
    messageHelper.displayError("Ocorreu um erro inesperado.");
    return false;
  }
};
